export const encodeFlowSegment = (value: string | number) =>
  typeof value === 'number' ? value : encodeURIComponent(value);

export const preventDuplicateCalls = () => {
  let isSubmitting = false;
  return async (callback: () => Promise<any>) => {
    if (isSubmitting) return;
    isSubmitting = true;
    try {
      return await callback();
    } finally {
      isSubmitting = false;
    }
  };
};
